/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../../util/loadingLayer';
import formMessages from '../../util/formMessages';

export default {
    init() {
        formMessages().useCaptcha();
        const $form = $('#presentation-submission-form');

        $form.find("label.file-name-label").each(function() {
            $(this).data('placeholder', $(this).text());
        });

        $('#type', $form).on('change', function() {
            const val = ($(this).val() || '').toLowerCase();
            const types = $(this).data('types');

            var accept = "";

            if (val.length && types[val]) {
                accept = val + ',' + types[val];

                const $formGroup = $(".custom-file-input", $form).closest('.form-group');
                $formGroup.find('.custom-file-input').removeClass('is-invalid is-valid').val('')

                const label = $formGroup.find("label.file-name-label");
                label.html(label.data('placeholder') || '').removeClass('is-invalid is-valid');
                $formGroup.find('.invalid-feedback').html('');
                
            }
            
            $(".custom-file-input", $form).attr('accept', accept);
        });

        $(".custom-file-input", $form).on("change", function() {
            var fileName = $(this).val().split("\\").pop();

            const label = $(this).siblings("label.file-name-label");
            
            if (!label.data('placeholder')) {
                label.data('placeholder', label.html());
            }

            if (!fileName) {
                fileName = label.data('placeholder');
            }

            $(this).siblings("label.file-name-label").removeClass('is-valid is-invalid').html(fileName);
        });
        
        formMessages($form).validate();
        $form.on('submit', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();
            formMessages($form).init();

            var formData = new FormData(this);
            formData.append('action', 'page-presentation-submission');
            formData.append('nonce', window.meta_object.nonce);
            formData.append('captcha_token', window.meta_object.captcha_token);

            const url = $(this).attr('action-ajax') || $(this).attr('action');
            const method = $(this).attr('method');

            $.ajax({
                url,
                method,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                complete: function() {
                    formMessages().reloadCaptcha();
                },
                success: function(data) {
                    if (!data) {
                        loadingLayer.hideLoading();
                        return;
                    }

                    if (data.success && data.successUrl) {
                        window.location.replace(data.successUrl);
                        return;
                    }
                    else if (data.success) {
                        loadingLayer.hideLoading();
                        $('.thank-you-message').removeClass('d-none');
                        $form.hide();

                        formMessages().scrollTo('.block-presentation-submission', 1000, 50);
                        return;
                    }
                    
                    loadingLayer.hideLoading();
                    formMessages($form, data).run();
                },
                error: function(err) {
                    console.log('error', err);
                    loadingLayer.hideLoading();
                }
            });
        });
    },
    finalize() {

    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/blocks/presentationSubmission.js